module.exports = __webpack_public_path__ + "img/1996.84471871.jpg";